import React from 'react';

import { Button } from '@components/Button';
import {
  ActionableDialog,
  ActionableDialogActions,
  ActionableDialogContent,
  ActionableDialogTitle,
} from '@components/Dialog';
import { makeMuiStyles } from '@styles';
import { formStrings } from '@utils/forms';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    unableToUnlock: (title: string) => (
      <>
        申し訳ありませんが、あなたのアカウントには{title}のロックを解除する権限がありません。
        <br />
        {title}のロックを解除する必要がある場合は、管理者に連絡してください。
        <br />
      </>
    ),
  },
});

const useStyles = makeMuiStyles(() => ({
  dialog: {
    maxWidth: 'initial !important',
    width: 618,
  },
}));

interface InstructionUnableToUnlockDialogProps {
  open: boolean;
  name: string;
  onClick: () => void;
}

export const InstructionUnableToUnlockDialog: React.FC<InstructionUnableToUnlockDialogProps> = (
  props,
) => {
  const { open, name, onClick } = props;
  const classes = useStyles();
  return (
    <ActionableDialog open={open} classes={{ paper: classes.dialog }}>
      <ActionableDialogTitle>{formStrings.unlock}</ActionableDialogTitle>
      <ActionableDialogContent style={{ padding: 55 }}>
        {strings.unableToUnlock(name)}
      </ActionableDialogContent>
      <ActionableDialogActions justifyContent="center">
        <Button
          color="primary"
          size="small"
          text={formStrings.ok}
          shape="round"
          type="button"
          onClick={onClick}
        />
      </ActionableDialogActions>
    </ActionableDialog>
  );
};
